export const blockIconsPhotoandimagePhotoLibraryNew = (
	<span className='material-symbols-outlined'>photo_library</span>
);
